import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../../../lib/enums";
import { show } from "../../../../../notifications/notifications";
import api from "../../../api";
import { DeleteLayoutPayload } from "../@types";
import { LAYOUT_DETAILS_KEY } from "./useGetLayoutDetails";
import { GET_LAYOUTS_QUERY_KEY } from "./useGetLayouts";
import useNavigationBlockContext from "./useNavigationBlockContext";

const useDeleteLayout = () => {
  const queryClient = useQueryClient();

  const { api: blockApi } = useNavigationBlockContext();

  const { mutateAsync } = useMutation({
    mutationKey: ["deleteLayout"],
    mutationFn: ({ id, type }: DeleteLayoutPayload) =>
      api.deleteLayout(id, type),
    onMutate: () => {
      blockApi.reset();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LAYOUT_DETAILS_KEY] });
      queryClient.refetchQueries({ queryKey: GET_LAYOUTS_QUERY_KEY });
      show({
        level: NotificationsLevel.SUCCESS,
        message: `Layout succesfully deleted!`
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: `Failed to delete layout!`
      });
    }
  });

  return { remove: mutateAsync };
};

export default useDeleteLayout;
